import plantDataConfigApi from '@/api/config/plantDataConfigApi'
import { queryKeys } from '@/constant/common'
import { useQuery } from '@tanstack/react-query'

function usePlantById(interfaceId: any, plantId: any) {
  return useQuery([[queryKeys.plant], plantId], async () => {
    if (!interfaceId || !plantId) return null
    const { data } = await plantDataConfigApi.getById(
      interfaceId.toString(),
      plantId.toString(),
    )
    if (!data) return null

    return data
  })
}

export default usePlantById
